export const APPROVAL_FLOWS_BY_REQUESTOR_KEY = 'approval_flows_by_requestor';
export const SEND_FOR_APPROVAL_FLOW_KEY = 'send_for_approval_flow';
export const GET_APPROVAL_FLOW_STATUS_KEY = 'get_approval_flow_status';
export const CHANGE_APPROVAL_FLOW_STATUS_KEY = 'change_approval_flow_status';
export const DELETE_APPROVAL_PROCESS_KEY = 'delete_approval_process';
export const GET_USERS = 'get_users';
export const GET_APPROVAL_PROCESS_DETAILS_KEY =
  'get_approval_process_details_key';
export const APPROVAL_STATUS_KEY = 'approval-status_key';
export const SEND_REMINDER_EMAIL_KEY = 'send_reminder_email_key';
